interface IV2TitleProps {
  title: string;
}

const V2Title: React.FC<IV2TitleProps> = ({ title }) => {
  return (
    <div className="w-full border-b border-stroke">
      <div className="-mb-px border-b-2 border-primary-900 w-fit">
        <p className="mx-3 my-4 text-xl font-semibold leading-6 text-primary-900">
          {title}
        </p>
      </div>
    </div>
  );
};

export default V2Title;
